import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "page-container"
};
const _hoisted_2 = { class: "grid" };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = { class: "card" };
const _hoisted_5 = { class: "flex flex-column gap-3 align-items-baseline mb-4" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("h3", { class: "headline" }, "Details", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, "Title", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", null, "Description", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { for: "image" }, "Image", -1);
const _hoisted_10 = {
    style: { "width": "100%" },
    id: "image"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("p", null, "Drag and drop files here to upload.", -1);
const _hoisted_13 = { class: "flex flex-column gap-3 align-items-baseline" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", { for: "content" }, "Content", -1);
const _hoisted_15 = { class: "my-3 flex flex-row justify-content-end gap-2" };
const _hoisted_16 = { class: "col" };
import Divider from "primevue/divider";
import FileUpload from "primevue/fileupload";
import Editor from "primevue/editor";
import CatalogCardLinksDisplayAndEdit from "@/components/templates/Catalog/CatalogCardLinksDisplayAndEdit.vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { getCatalogCardById, updateCard } from "@/repositories/catalog-card.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { computed, onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import { mandatoryField } from "@/shared/utils/validation";
import OneDeskTextArea from "@/components/atoms/OneDeskTextArea.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CardDetailsEdit',
    setup(__props) {
        const notify = useToastNotify();
        const route = useRoute();
        const router = useRouter();
        const imgBase64 = ref(null);
        const blobUrl = ref("");
        const cardId = computed(() => route.params.cardId?.toString());
        const catalogCard = ref({
            id: "",
            title: "",
            content: "",
            pictureUri: "",
            base64Picture: "",
            sharepointRedirectUrl: "",
            confluenceRedirectUrl: "",
            jiraRedirectUrl: "",
            otherRedirectUrl: "",
            scope: "",
            audience: "",
            keywords: "",
            mailtoAddress: "",
            description: "",
            categoryId: "",
        });
        const validComponents = ref({});
        const disabled = computed(() => Object.values(validComponents.value).some((value) => !value));
        const onSave = async () => {
            if (catalogCard.value) {
                if (imgBase64.value)
                    catalogCard.value.image = imgBase64.value;
                await updateCard(constructInputFromCatalogCard(catalogCard.value));
                await getCardById();
                imgBase64.value = null;
                notify("", `Card : ${catalogCard.value?.title} has been successfully updated`, "success");
                await router.push({
                    name: "CardDetailsPage",
                    params: { cardId: cardId.value },
                });
            }
        };
        const onImageUpload = (event) => {
            if (event.files && event.files[0]) {
                blobUrl.value = event.files[0].objectURL;
                const reader = new FileReader();
                reader.onload = (e) => imgBase64.value = e.target?.result;
                reader.readAsDataURL(event.files[0]);
            }
        };
        onBeforeMount(async () => {
            await getCardById();
        });
        const getCardById = async () => {
            if (cardId.value) {
                catalogCard.value = await getCatalogCardById(cardId.value);
            }
        };
        const onCancelClick = () => {
            if (cardId.value) {
                router.push({
                    name: "CardDetailsPage",
                    params: { cardId: cardId.value },
                });
            }
        };
        const constructInputFromCatalogCard = (card) => {
            return {
                id: card.id,
                title: card.title,
                content: card.content,
                base64Picture: card.base64Picture,
                scope: card.scope,
                audience: card.audience,
                keywords: card.keywords,
                mailtoAddress: card.mailtoAddress,
                description: card.description,
                categoryId: card.categoryId,
                image: card.image
            };
        };
        return (_ctx, _cache) => {
            return (catalogCard.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _hoisted_6,
                                    _createVNode(OneDeskInput, {
                                        style: { "width": "100%" },
                                        rules: [_unref(mandatoryField)],
                                        modelValue: catalogCard.value.title,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((catalogCard.value.title) = $event)),
                                        placeholder: "Enter a title",
                                        "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (validComponents.value.title = $event))
                                    }, {
                                        label: _withCtx(() => [
                                            _hoisted_7
                                        ]),
                                        _: 1
                                    }, 8, ["rules", "modelValue"]),
                                    _createVNode(OneDeskTextArea, {
                                        rows: 5,
                                        cols: 35,
                                        style: { "width": "100%" },
                                        rules: [_unref(mandatoryField)],
                                        modelValue: catalogCard.value.description,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((catalogCard.value.description) = $event)),
                                        label: "Description",
                                        placeholder: "Enter a description",
                                        "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (validComponents.value.title = $event))
                                    }, {
                                        label: _withCtx(() => [
                                            _hoisted_8
                                        ]),
                                        _: 1
                                    }, 8, ["rules", "modelValue"]),
                                    _hoisted_9,
                                    _createElementVNode("div", _hoisted_10, [
                                        (catalogCard.value.imageUri)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                width: "200",
                                                height: "150",
                                                class: "displayed-image mb-3",
                                                src: catalogCard.value.imageUri,
                                                loading: "lazy"
                                            }, null, 8, _hoisted_11))
                                            : _createCommentVNode("", true),
                                        _createVNode(_unref(FileUpload), {
                                            onSelect: _cache[4] || (_cache[4] = ($event) => (onImageUpload($event))),
                                            multiple: false,
                                            accept: ".png, .jpg, .jpeg",
                                            maxFileSize: 1000000,
                                            showCancelButton: true,
                                            showUploadButton: false,
                                            fileLimit: 1,
                                            "cancel-icon": "pi pi-times-circle"
                                        }, {
                                            empty: _withCtx(() => [
                                                _hoisted_12
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _hoisted_14,
                                    _createVNode(_unref(Editor), {
                                        modelValue: catalogCard.value.content,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((catalogCard.value.content) = $event)),
                                        editorStyle: "height: 300px",
                                        id: "content"
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createVNode(_unref(Divider)),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(OneDeskButton, {
                                        onClick: onSave,
                                        label: "Save",
                                        icon: "pi pi-save",
                                        disabled: disabled.value
                                    }, null, 8, ["disabled"]),
                                    _createVNode(OneDeskButton, {
                                        severity: "secondary",
                                        label: "Cancel",
                                        icon: "pi pi-times-circle",
                                        onClick: onCancelClick
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            (cardId.value)
                                ? (_openBlock(), _createBlock(CatalogCardLinksDisplayAndEdit, {
                                    key: 0,
                                    "entity-id": _unref(route).params.cardId
                                }, null, 8, ["entity-id"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
